import { QueryClient } from '@tanstack/react-query';

const PRODUCT_DEMO_DOMAIN_QUERY_KEYS = new Set([
  'properties',
  'leases',
  'tenants',
  'invoices',
  'payments',
  'reminder_actions',
  'reminder_templates',
  'comm_events',
  'invoice_edit_history',
  'lessors',
  'user-meta',
  'tenant-user-meta',
  'tenant-invite-link',
  'property-edit-history',
  'lease-edit-history',
  'invoice-edit-history',
]);

export const isProductDemoDomainQueryKey = (queryKey: unknown) => {
  if (!Array.isArray(queryKey)) return false;

  return PRODUCT_DEMO_DOMAIN_QUERY_KEYS.has(String(queryKey[0]));
};

export const removeProductDemoDomainQueries = (queryClient: QueryClient) => {
  queryClient.removeQueries({
    predicate: (query) => isProductDemoDomainQueryKey(query.queryKey),
  });
};
